import { render } from "./AutomanSsoView.vue?vue&type=template&id=3db768f0&scoped=true"
import script from "./AutomanSsoView.vue?vue&type=script&lang=js"
export * from "./AutomanSsoView.vue?vue&type=script&lang=js"

import "./AutomanSsoView.vue?vue&type=style&index=0&id=3db768f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db768f0"]])

export default __exports__